import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const customer = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE', 'CP-S'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'packpl_id': {
    title: '计划单号',
    type: 'input'
  },
  'customer': {
    title: '客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  's_name': {
    title: '客户名称',
    type: 'input',
    equation: all
  },
  's_datum': {
    title: '日期',
    type: 'date',
    equation: all
  },
  's_matnr': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品'
    }
  },
  's_salescenter': {
    title: '营销单元',
    type: 'select',
    equation: city,
    dictionary: 'sale'
  },
  's_type': {
    title: '单据类型',
    type: 'select',
    equation: city,
    dictionary: 'A0012'
  },
  's_preorder': {
    title: '预约',
    type: 'select',
    equation: all,
    dictionary: 'B0099'
  }
}

export const config1 = {
  'packpl_id': {
    title: '材料计划单'
  },
  'product_id': {
    title: '产品编码',
    width: 200
  },
  'description': {
    title: '产品描述',
    width: 400
  },
  'name1': {
    title: '客户',
    width: 250
  },
  'customertype': {
    title: '客户类型'
  },
  'remark': {
    title: '备注'
  },
  'version': {
    title: '版本号'
  },
  'planqty_box': {
    title: '计划数量(件)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_bottle': {
    title: '计划数量(瓶)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_ton': {
    title: '计划数量(瓶)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'avlable_qty': {
    title: '可用数量',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'unlimtd_qty': {
    title: '未到周期总量',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'status': {
    title: '状态'
  },
  'packsum_id': {
    title: '汇总单号'
  },
  'uname': {
    title: '创建人'
  },
  'mdate': {
    title: '提交日期'
  }
}

export const config2 = {
  'packsum_id': {
    title: '汇总单号'
  },
  'product_id': {
    title: '产品编码',
    width: 200
  },
  'description': {
    title: '产品描述',
    width: 400
  },
  'version': {
    title: '版本号'
  },
  'planqty_box': {
    title: '计划数量(件)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_bottle': {
    title: '计划数量(瓶)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_ton': {
    title: '计划数量(吨)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'status': {
    title: '同步状态'
  },
  'remark': {
    title: '备注',
    slot: true,
    width: 200
  }
}



// WEBPACK FOOTER //
// ./src/views/material-plan-manage/config/materialSumOrder.js